// extracted by mini-css-extract-plugin
export default {"activateAccount":"styles_activateAccount__wNAvr","form":"styles_form__xpXe2"};